import { RelationshipProgressStatus } from '~/models/relationship';
export function toRelationshipProgressStatus(progressStatus) {
    var _Object_values_find;
    return (_Object_values_find = Object.values(RelationshipProgressStatus).find((v)=>v === progressStatus)) !== null && _Object_values_find !== void 0 ? _Object_values_find : RelationshipProgressStatus.Sent;
}
